<template>
    <div class="map-main">

        <!-- Configuration from Algolia -->
<!--        <ais-configure :filters="filters" />-->

        <!-- Blocker -->
        <div class="map-blocker" v-if="isContentBlocked != false" data-modal="join-the-club"></div>

        <!-- Google Map -->
        <div v-if="state" class="ais-GeoSearch">
            <googlemaps-map
                @idle="onMapReady"
                ref="map"
                :options="mapOptions"
                :center.sync="center"
                :zoom.sync="zoom"
                class="ais-GeoSearch-map map-wrap"
                @dragend="boundsChanged"
            >
                <googlemaps-marker
                    v-for="item of state.items"
                    :key="item.objectID"
                    :ref="item.id"
                    :icon="getMarkerIcon(item)"
                    :title="item.name"
                    :info="{ test: 'hello'}"
                    :position="item._geoloc"
                    @click="onMarkerClick(item)"
                    @mouseover="onMarkerMouseOver(item)"
                    @mouseout="onMarkerMouseLeave(item)"
                    :z-index="item.category.slug == 'eat' ? 300 : 200"
                />
            </googlemaps-map>
        </div>

        <!-- Discover View Button -->
        <a :href="`/destination/${city.slug}`" class="map-cta">
            Discover View
            <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
        </a>

        <!--Show while we load the Map -->
        <div class="loader alt-loader" style="background: rgb(225, 223, 219)">
            <div class="loader-content">
                <div class="star-wrapper">
                    <svg class="star"><use xlink:href="#star"></use></svg>
                    <svg class="mask"><use xlink:href="#mask-alt"></use></svg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import MapsHelpers from '@/mixins/MapsHelpers'
import { createWidgetMixin } from 'vue-instantsearch';
import { connectGeoSearch } from 'instantsearch.js/es/connectors';


export default {


    mixins: [createWidgetMixin({connector: connectGeoSearch}), MapsHelpers],

    props: ['city', 'isContentBlocked'],

    data() {
        return {
            filters: `city.title:"${this.city.title}"`,
            infowindow : null,
            mapOptions: null,
            firstLoaded: true,
            center: {lat: 0, lng: 0},
            zoom: 12,
        };
    },

    created() {

        this.mapOptions = {
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            styles: this.mapStyles
        }

        eventBus.$on('markerBigger', this.makeMarkerBig);
        eventBus.$on('markerSmall', this.makeMarkersSmall);

        if (this.city && this.city.map_lat_override && this.city.map_lng_override) {
            this.center = {
                lat: this.city.map_lat_override,
                lng: this.city.map_lng_override
            }
        }
    },

    methods: {

        onMapReady() {
            this.infowindow = new google.maps.InfoWindow({
                content: ``
            });
            $("html, body").animate({scrollTop: 0})
            this.$nextTick(() => {
                $('.map-main .loader').hide();
            })
            eventBus.$emit('googleMapIsReady')
        },

        onMarkerMouseOver(item) {
            this.setInfoWindowContent(item)
            this.infowindow.open(this.$refs.map.$_map, this.$refs[item.id][0].$_marker);
        },

        onMarkerMouseLeave(item) {
            this.infowindow.close()
        },

        onMarkerClick(item) {
            this.setInfoWindowContent(item)
            this.infowindow.open(this.$refs.map.$_map, this.$refs[item.id][0].$_marker);
            eventBus.$emit('moveScrollToSpot', item.id);
        },

        setInfoWindowContent(item) {
            let routeUrl = `/${item.city.slug}/${item.slug}`;
            this.infowindow.setContent(`<a href="${routeUrl}">
                <div class="map-info-window">${item.name}<br />
                    <span>${item.category.title}</span>
                    <small>Details</small>
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                </div>
            </a>`)
        },

        getMarkerIcon(item) {
            return {
                url: this.icons[item.category.slug].icon,
                scaledSize: window.google ? new google.maps.Size(25, 29) : null,
            }
        },

        boundsChanged() {
            this.infowindow.close()
            let bounds = this.$refs.map.$_map.getBounds();
            var southWest = bounds.getSouthWest();
            var northEast = bounds.getNorthEast();
            this.filters = ``;
            this.state.refine({
                northEast: {
                    lat: northEast.lat(),
                    lng: northEast.lng(),
                },
                southWest: {
                    lat: southWest.lat(),
                    lng: southWest.lng(),
                }
            })
            this.$emit('bounds-changed')
        },

        makeMarkerBig(spot) {
            this.makeMarkersSmall(spot);
            let marker = this.$refs[spot.id][0].$_marker
            if (marker) {
                var icon = {
                    url: this.icons[spot.category.slug].icon,
                    scaledSize: new google.maps.Size(30, 35),
                };
                marker.setIcon(icon);
                marker.setZIndex(500);
                google.maps.event.trigger(marker, 'mouseover');
            }
        },

        makeMarkersSmall(spot) {
            this.infowindow.close()
            let marker = this.$refs[spot.id][0].$_marker
            if (marker) {
                marker.setIcon({
                    url: this.icons[spot.category.slug].icon,
                    scaledSize: new google.maps.Size(25, 29),
                });
                marker.setZIndex((spot.category.slug == 'eat' ? 300 : 200));
            }
        },
    },

    watch: {
        'state.items'() {
            if(this.firstLoaded) {
                this.firstLoaded = false
                if (this.state.items.length && this.center.lat == 0 && this.center.lng == 0) {
                    this.center = this.state.items[0]._geoloc
                }
            }
        }
    }
}
</script>

<style>
.ais-GeoSearch-map {
    height: calc(100vh - 70px);
}
</style>
